export enum NotificationAction {
    NONE = '',
    WELCOME_MESSAGE = 'welcome_message',
    PROJECT_COMMENT_ADDED = 'project_comment_added',
    PROJECT_EDITED_BY = 'project_edited_by',
    PROJECT_MEMBER_INVITE = 'project_member_invite',
    FOLDER_MEMBER_INVITE = 'folder_member_invite',
    ENTERPRISE_USER_LINK_REQUEST = 'enterprise_user_link_request',
    ENTERPRISE_USER_LINK_APPROVED = 'enterprise_user_link_approved',
    ENTERPRISE_USER_UNLINKED = 'enterprise_user_unlinked',
    ACCOUNT_EMAIL_CHANGED = 'account_email_changed',
    ACCOUNT_PASSWORD_CHANGED = 'account_password_changed',
    SUBSCRIPTION_CHANGED = 'subscription_changed',
    SUBSCRIPTION_STATE_CHANGED = 'subscription_state_changed',
    SUBSCRIPTION_BILLING_FAILED = 'subscription_billing_failed',
    SUBSCRIPTION_EXPIRING_SOON = 'subscription_expiring_soon',
    PAYMENT_FAILED = 'payment_failed',
    PAYMENT_ACTION_REQUIRED = 'payment_action_required',
    BUDGET_WARNING = 'budget_warning',
    BUDGET_LIMIT_REACHED = 'budget_limit_reached',
    GUEST_ESTIMATE_REQUESTED = 'guest_estimate_requested',
    ENTERPRISE_ROLE_CHANGED = 'enterprise_role_changed',
    ENTERPRISE_USER_LINK_DECLINED = 'enterprise_user_link_declined',
    PLAN_CHANGE_EXPIRED = 'plan_change_expired',
    // An API key made before access settings stops working on a date.
    API_KEY_RETIRING = 'api_key_retiring',
    // The files someone imported are all in (or failed), however long ago the page that started it closed.
    IMPORT_FINISHED = 'import_finished',
    // The plan's price changes at a renewal at least 30 days away, as the email said (common/utils/price-change.ts).
    PRICE_CHANGE = 'price_change',
    // That new price takes effect: the subscription is on it from its next renewal.
    PRICE_CHANGE_APPLIED = 'price_change_applied',
    PROJECTS_OWNERSHIP_TRANSFERRED = 'projects_ownership_transferred',

    // Every email has its notification (owner, 2026-10-30). Shown through
    // NotificationsService's EMAIL_NOTICES: words notif_<action>[_<variant>],
    // values in `args` ('text:', 'date:', 'money:', 'plan:', 'count:').
    TWO_FACTOR_ENABLED = 'two_factor_enabled',
    TWO_FACTOR_REMOVED = 'two_factor_removed',
    RECOVERY_CODES_ISSUED = 'recovery_codes_issued',
    SIGNED_OUT_EVERYWHERE = 'signed_out_everywhere',
    NEW_SIGN_IN = 'new_sign_in',
    EMAIL_CHANGED_BY_SUPPORT = 'email_changed_by_support',
    ADMIN_RIGHTS_CHANGED = 'admin_rights_changed',
    RELEASE_ANNOUNCEMENT = 'release_announcement',
    SUPPORT_TICKET_RECEIVED = 'support_ticket_received',
    SUPPORT_REPLY = 'support_reply',
    PAYMENT_RECEIVED = 'payment_received',
    REFUND_ISSUED = 'refund_issued',
    RENEWAL_REMINDER = 'renewal_reminder',
    CARD_EXPIRING = 'card_expiring',
    SEATS_CHANGED = 'seats_changed',
    SUBSCRIPTION_PAUSED = 'subscription_paused',
    SUBSCRIPTION_RESUMED = 'subscription_resumed',
    PAYMENT_SWITCHED = 'payment_switched',
    LEAD_MISSED = 'lead_missed',
    GUEST_PROJECT_STARTED = 'guest_project_started',
    REMOVED_FROM_PROJECT = 'removed_from_project',
    ENTERPRISE_JOINED = 'enterprise_joined',
    ENTERPRISE_ADDED = 'enterprise_added',
    ENTERPRISE_SSO_CHANGED = 'enterprise_sso_changed',
    ENTERPRISE_SEAT_LIMIT = 'enterprise_seat_limit',
    ENTERPRISE_PASSWORD_SET = 'enterprise_password_set',
    ENTERPRISE_SIGNED_OUT = 'enterprise_signed_out',
    ENTERPRISE_MEMBER_SUSPENDED = 'enterprise_member_suspended',
    PARTNER_INVITATION = 'partner_invitation',
    PARTNER_ACCEPTED = 'partner_accepted',
    PARTNER_DECLINED = 'partner_declined',
    PARTNER_CARD_NEEDED = 'partner_card_needed',
    PARTNER_STARTED = 'partner_started',
    PARTNER_KEPT = 'partner_kept',
    PARTNER_CHANGED = 'partner_changed',
    PARTNER_CLIENT_ENDING = 'partner_client_ending',
    PARTNER_CLIENT_ENDED = 'partner_client_ended',
    PARTNER_WITHDRAWN = 'partner_withdrawn',
    PARTNER_INVITATION_LAPSED = 'partner_invitation_lapsed',
    API_KEY_CREATED = 'api_key_created',
    API_KEY_REVOKED = 'api_key_revoked',
    API_KEY_SITES_LOOSENED = 'api_key_sites_loosened',
    API_KEY_STAFF_ACTION = 'api_key_staff_action',
    WEBHOOK_SECRET_ROTATED = 'webhook_secret_rotated',
    WEBHOOK_DISABLED = 'webhook_disabled',
    // Authorized developers: to the owner, a developer asks; to the
    // developer, the owner approved or authorized (variant approved |
    // authorized), declined, or took it back.
    EMBED_ACCESS_REQUESTED = 'embed_access_requested',
    EMBED_ACCESS_GRANTED = 'embed_access_granted',
    EMBED_ACCESS_DECLINED = 'embed_access_declined',
    EMBED_ACCESS_REVOKED = 'embed_access_revoked',
}
